import { StoreCategoriesResultEntity } from './storecategoriesresponse';
import { StoreCapableItemTypesResultEntity } from './storecapableitemtypesresponse';

export class StoreItemFilterInfo {
    myRequested: boolean | null;
    storeCategories: (StoreCategoriesResultEntity)[] | null;
    storeCapableItemTypes: (StoreCapableItemTypesResultEntity)[] | null;
    searchTerm: String;
}

